module.exports = __webpack_public_path__ + "img/vlx.7f1cf592.svg";